// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3hvuh","alert":"SettungsInbox_alert__Z-3ca"};